<template>
    <div class="exception-view">
        <ele-icon403></ele-icon403>
        <div class="result-title">企业站未开通</div>
        <div class="result-subtitle">建议您使用大国工匠客户端</div>
        <div class="result-extra">
            <a href="https://down.global-dsc.cn/Release/dggj/dggj.exe" target="_blank">
                <el-button type="primary" size="medium">下载大</el-button>
            </a>
        </div>
    </div>
</template>

<script>
import EleIcon403 from './403.vue';
export default{
    components: { EleIcon403 }
}
</script>

<style lang="less" scoped>
    .exception-view{
        width: 100vw;
        padding-top: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }
    .result-title{
        color: #000000d9;
        font-size: 24px;
        line-height: 1.8;
        text-align: center;
        margin-top: 20px;
        margin-bottom: 8px;
    }
    .result-subtitle {
        color: #00000073;
        font-size: 14px;
        line-height: 1.6;
        text-align: center;
    }
    .result-extra{
        margin-top: 24px;
    }
</style>